module.exports = __webpack_public_path__ + "img/szhx_titIcon3.6db266ec.png";